// extracted by mini-css-extract-plugin
export default {"header":"Header_header__GQma6","title":"Header_title__4vkZJ","description":"Header_description__k24-J","error":"Header_error__aZsEG"};